import { render, staticRenderFns } from "./ConsultancyTransfer.vue?vue&type=template&id=d3495456&scoped=true&"
import script from "./ConsultancyTransfer.vue?vue&type=script&lang=js&"
export * from "./ConsultancyTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ConsultancyTransfer.vue?vue&type=style&index=0&id=d3495456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3495456",
  null
  
)

export default component.exports